// client/src/inquiries/InquiryList.tsx
import React, { Fragment, useCallback, SyntheticEvent } from 'react';
import {
    List, Datagrid, TextField, EditButton, NumberField,
    useListContext, TextInput, FunctionField, ListProps,
    DateInput
} from 'react-admin';
import { Tabs, Tab, useMediaQuery, Theme } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import useAdmin from '../hooks/useAdmin';
import useAuthorize from '../hooks/useAuthorize';
import { IInquiry } from '../types/types';
import { UserRole } from '../types/types';

// 🔹 Status tabs
const tabs = [
    { id: '1', name: 'Pending' },
    { id: '2', name: 'Approved' },
    { id: '3', name: 'Rejected' },
];

// 🔹 Search filters
const inquiryFilters = [
    <TextInput label="Customer Number" source="customer_contact" alwaysOn />,
    <TextInput label="Product Name" source="product_name" />,
    <DateInput label="Inquiry Date" source="inquiry_date" key="inquiry-date" />,
];

const TabbedDatagrid = () => {
    const { filterValues, setFilters, displayedFilters } = useListContext();
    const theme: Theme = useTheme();
    const isXSmall = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();

    const handleChange = useCallback(
        (_event: SyntheticEvent, value: string) => {
            setFilters({ ...filterValues, status: value }, displayedFilters);
        },
        [filterValues, setFilters, displayedFilters]
    );

    useAuthorize([UserRole.Admin, UserRole.ProductAdmin]);

    return (
        <Fragment>
            <Tabs
                value={filterValues.status || '1'}
                onChange={handleChange}
                centered
                style={{ marginBottom: 10 }}
            >
                {tabs.map(choice => (
                    <Tab key={choice.id} label={choice.name} value={choice.id} />
                ))}
            </Tabs>

            <Datagrid>
                <NumberField source="id" label="ID" />
                <TextField source="inquiry_date" label="Inquiry Date" />
                <TextField source="customer_contact" label="Customer" />
                <TextField source="product_name" label="Product Name" />
                <TextField source="product_grade" label="Product Grade" />
                <TextField source="inquiry_city_name" label="Inquiry City" />
                <NumberField
                    source="inquiry_quantity"
                    label="Quantity"
                    options={{ maximumFractionDigits: 0, minimumFractionDigits: 0 }}
                />
                <NumberField source="inquiry_price" label="Price" />
                <NumberField
                    source="accepted_inquiry_quantity"
                    label="Accepted Qty"
                    options={{ maximumFractionDigits: 0, minimumFractionDigits: 0 }}
                />
                <NumberField source="accepted_inquiry_price" label="Accepted Price" />
                <NumberField source="inquiry_total" label="Total" />
                <TextField source="inquiry_order_id" label="Order ID" />
                <EditButton />
            </Datagrid>
        </Fragment>
    );
};

export const InquiryList = (props: ListProps) => (
    <List
        {...props}
        filters={inquiryFilters}
        filterDefaultValues={{ status: '1' }}
    >
        <TabbedDatagrid />
    </List>
);

export default InquiryList;

